{
  "yes": "Tak",
  "no": "Nie",
  "ok": "Ok",
  "cancel": "Anuluj",
  "messages": {
    "confirmCloseWarning": "Wprowadzone zmiany nie zostaną zapisane. Czy chcesz kontynuować?"
  }
}
